<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const usuario = ref('')
const senha = ref('')
const erro = ref('')
const router = useRouter()

const login = async () => {
  erro.value = ''
  try {
    const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include', // IMPORTANTE para enviar/receber cookies HttpOnly
      body: JSON.stringify({
        username: usuario.value,
        password: senha.value
      })
    })

    if (!response.ok) {
      throw new Error('Usuário ou senha inválidos')
    }

    router.push('/integratoradm/dashboard')
  } catch (err) {
    erro.value = err.message
  }
}
</script>

<template>
  <div class="h-screen flex items-center justify-center bg-gray-100">
    <div class="bg-white p-8 rounded shadow-md w-96">
      <h2 class="text-xl font-bold mb-6 text-center">Área Administrativa</h2>
      <input v-model="usuario" type="text" placeholder="Usuário" class="input mb-4" />
      <input v-model="senha" type="password" placeholder="Senha" class="input mb-4" />
      <button @click="login" class="bg-blue-600 text-white px-4 py-2 rounded w-full">Entrar</button>
      <p v-if="erro" class="text-red-600 text-sm mt-2 text-center">{{ erro }}</p>
    </div>
  </div>
</template>

<style scoped>
.input {
  @apply border border-gray-300 rounded px-4 py-2 w-full;
}
</style>
